import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { WorkshopJobHistoryListComponent } from '../../workshop-job-history-list/workshop-job-history-list.component';

@Component({
  selector: 'app-workshop-job-history',
  templateUrl: './workshop-job-history.component.html',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    WorkshopJobHistoryListComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class WorkshopJobHistoryComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WorkshopJobHistoryComponent>
  ) {}

  get repairableName() {
    if (this.data.type === 'item') {
      return this.data.repairable.code;
    }
    return this.data.repairable.name;
  }
}
